import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectFinancialEntityNameState } from '../selectors';

export const getData = createSelector(selectFinancialEntityNameState, (state: State) => state.data);

export const getError = createSelector(selectFinancialEntityNameState, (state: State) => state.error);

export const getLoading = createSelector(selectFinancialEntityNameState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult) => T) =>
  createSelector(selectFinancialEntityNameState, (state: State) => fn(state.data));
